import _ from 'lodash';
import contentService from '../services/contentService';
import { ContentAction } from '../types/ContentAction';
import ContentData from '../types/ContentData';
import { ContentListFilterData } from '../types/ContentFilterData';
import { SyllabusAction } from '../types/SyllabusAction';
import { UPDATE_QUESTION_BENCHMARKS } from './actionType';

const list = (filter: ContentListFilterData, page = 1, limit = 20, loader = true) => (dispatch: any) => {
  const success = (data: ContentData[], statusCode: number): ContentAction =>
    ({ type: 'CONTENT_DATA_SUCCESS', data, statusCode });
  const failure = (error: string): ContentAction =>
    ({ type: 'CONTENT_DATA_FAILED', data: [] });

  if(loader){
    contentService.contentList(filter, page, limit)
    .then(
      (res: any) => { dispatch(success(res.contents, res.statusCode)) },
      err => { dispatch(failure(err)) }
    );

  }
  else{
    // extra api call on course filter in mylibrary
  }  
  
  
}

const userList = () => (dispatch: any) => {
  const success = (data: any) =>
      ({ type: 'USER_FILTER_DATA_SUCCESS', data });
  const failure = (error: string) =>
    ({ type: 'USER_FILTER_DATA_FAILED', data: [] });

  contentService.getUserForFilter()
    .then(
      (res: any) => { dispatch(success(res)) },
      err => { dispatch(failure(err)) }
    );
}

const updateTestId = (data: any) => (dispatch: any) => {
  const update = (payload: any): SyllabusAction =>
      ({ type: 'UPDATE_TEST_ID', payload });
      dispatch(update(data))
}

const setModalFunction = (data: any) => (dispatch: any) => {
  const update = (payload: any): SyllabusAction =>
      ({ type: 'SET_MODAL_FUNCTION', payload });
      dispatch(update(data))
}


const getAutoQuestions = (data: any) => (dispatch: any) => {
  const update = (payload: any): SyllabusAction =>
      ({ type: 'GET_AUTO_GENERATE', payload });
       dispatch(update(data));
}
const getAutoQuesCount=(data:any)=> (dispatch: any) => {
  const update = (payload: any): SyllabusAction =>
      ({ type: 'GET_COUNT_AUTO_GENERATE', payload });
       dispatch(update(data));
}     
const fetchEditLockInfo = (data: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
      ({ type: 'FETCH_EDIT_LOCK_INFO', data: payload });
      dispatch(update(data))
}

const resetEditLockInfo = (data: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
      ({ type: 'RESET_EDIT_LOCK_INFO', data: payload });
      dispatch(update(data))
}

const updateContent = (data: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
      ({ type: 'UPDATE_CONTENT', data: payload });
      dispatch(update(data))
}

const updateQuestionBenchmarks = (data: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
      ({ type: UPDATE_QUESTION_BENCHMARKS, data: payload });
      dispatch(update(data))
}

const fetchBenchMarkInfo = (data: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
      ({ type: 'FETCH_BENCHMARK', data: payload });
      dispatch(update(data))
}

const updateBenchMarkInfo = (data: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
      ({ type: 'UPDATE_BENCHMARK', data: payload });
      dispatch(update(data))
}

const resetBenchMarkInfo = () => (dispatch: any) => {
  const update = (): ContentAction =>
      ({ type: 'RESET_BENCHMARK'});
      dispatch(update())
}

const fetchGoalLevels = (data: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
      ({ type: 'FETCH_GOAL_LEVELS', data: payload });
      dispatch(update(data))
}

const templateChanged = (value: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
      ({ type: 'TEMPLATE_CHANGED', data: payload });
      dispatch(update(value))
}
const questionCompleted = (value: any) => (dispatch: any) => {
  const update = (payload: any): ContentAction =>
    ({ type: 'QUESTION_COMPLETED', data: payload });
  dispatch(update(value))
}

const clearContentListData = () => (dispatch: any) => {

const update = (): ContentAction =>
      ({ type: 'CLEAR_CONTENT_LIST', data: [] });
      dispatch(update())
}

const setRequiresForceSaveForChallenge = (payload: boolean) => {
  return {
    type: 'SET_REQUIRES_FORCE_SAVE_FOR_CHALLENGE',
    data: payload
  }
}
const setContentSuggestions=(payload:any)=>{
  return {
    type:'SET_CONTENT_SUGGESTIONS',
    data:payload
  }
}
const contentActions = {
  list,
  userList,
  updateTestId,
  setModalFunction,
  fetchEditLockInfo,
  resetEditLockInfo,
  updateContent,
  updateQuestionBenchmarks,
  fetchBenchMarkInfo,
  updateBenchMarkInfo,
  fetchGoalLevels,
  templateChanged,
  questionCompleted,
  resetBenchMarkInfo,
  clearContentListData,
  setRequiresForceSaveForChallenge,
  getAutoQuestions,
  getAutoQuesCount,
  setContentSuggestions
};

export default contentActions;